export default __webpack_public_path__ + "static/media/ctoken-usdc.751577b9.svg";